import type { IntegrationStatus } from '@littlebird/ui-utils';

// 'disconnected' is intentionally omitted: nothing renders it (Composio filters
// disconnected rows out of the list, MCP has no such status), and StatusBadge
// returns null for it before this config is ever consulted.
export const integrationStatusConfig: Record<
  Exclude<IntegrationStatus, 'disconnected'>,
  { label: string; className: string }
> = {
  connected: {
    label: 'Connected',
    className:
      'text-green-700 bg-green-100 dark:text-green-400 dark:bg-green-900/30',
  },
  probing: {
    label: 'Checking...',
    className: 'text-foreground-subtle bg-secondary animate-pulse',
  },
  pending: {
    label: 'Pending',
    className: 'text-foreground-subtle bg-secondary animate-pulse',
  },
  failed: {
    label: 'Disconnected',
    className: 'text-red-600 bg-red-100 dark:text-red-400 dark:bg-red-900/30',
  },
  expired: {
    label: 'Expired',
    className:
      'text-amber-700 bg-amber-100 dark:text-amber-400 dark:bg-amber-900/30',
  },
  unauthorized: {
    label: 'Unauthorized',
    className: 'text-red-600 bg-red-100 dark:text-red-400 dark:bg-red-900/30',
  },
  unreachable: {
    label: 'Unreachable',
    className: 'text-red-600 bg-red-100 dark:text-red-400 dark:bg-red-900/30',
  },
  cancelled: {
    label: 'Cancelled',
    className:
      'text-amber-700 bg-amber-100 dark:text-amber-400 dark:bg-amber-900/30',
  },
  disabled: {
    label: 'Disabled',
    className: 'text-foreground-subtle bg-secondary',
  },
};
